import { DateTimePicker, StaticDateTimePicker, StaticTimePicker, TimePicker } from "@mui/x-date-pickers";
import { useMemo } from "react";
import { makeStyles } from "tss-react/mui";
import moment from "moment";
import { jsx as _jsx } from "react/jsx-runtime";
var useStyles = makeStyles()(function (theme) { return ({ paddingBottom: { marginBottom: theme.spacing(2) } }); });
export function TTimePicker(props) { var styles = useStyles().classes; var value = useMemo(function () { return moment(props.value); }, [props.value]); if (props.showDate) {
    if (props.variant === "static") {
        return /*#__PURE__*/ _jsx(StaticDateTimePicker, { className: styles.paddingBottom, value: value, onChange: function (value) { if (!value) {
                props.onChange(null);
                return;
            } props.onChange(value.toDate()); } });
    }
    return /*#__PURE__*/ _jsx(DateTimePicker, { className: styles.paddingBottom, label: props.label, format: "YYYY-MM-DD hh:mm a", value: value, onChange: function (value) { if (!value) {
            props.onChange(null);
            return;
        } props.onChange(value.toDate()); } });
} if (props.variant === "static") {
    return /*#__PURE__*/ _jsx(StaticTimePicker, { className: styles.paddingBottom, value: value, onChange: function (value) { if (!value) {
            props.onChange(null);
            return;
        } props.onChange(value.toDate()); } });
} return /*#__PURE__*/ _jsx(TimePicker, { className: styles.paddingBottom, label: props.label, format: "hh:mm a", value: value, onChange: function (value) { if (!value) {
        props.onChange(null);
        return;
    } props.onChange(value.toDate()); } }); }
